import { useEffect } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata, validateContentFromMetadata } from '@jutro/uiconfig';
import { valueTypeMap, getComponentDataType, getPropDataType } from '../../ScheduleItemsUtil';
import messages from './SimpleScheduleItem.messages';

function formatAvailableValues(availableValues) {
    return _.sortBy(availableValues, 'priority')
        .map((availableValue) => ({
            code: availableValue.code,
            name: availableValue.displayKey
        }));
}

function hasErrors(scheduleItem, value, path, modalData) {
    const isFirstItem = _.isEmpty(scheduleItem.scheduleItems);
    const isValueUnique = scheduleItem.scheduleItems.filter((item) => {
        return item.itemNumber !== modalData.itemNumber;
    })
        .every((item) => {
            const itemValue = _.get(item, path);
            return itemValue !== value;
        });

    return !isValueUnique && !isFirstItem;
}

function getValidationMessage(isUnique, scheduleItem, value, path, modalData, translator) {
    return (isUnique && hasErrors(scheduleItem, value, path, modalData)
        ? [translator(messages.thisFieldMustBeUnique)] : undefined)
        || (value === 0.00 ? [translator(messages.requiredField)] : undefined);
}

export default function SimpleScheduleItem({
    info,
    translator,
    modalData,
    scheduleItem,
    onValueChange,
    onValidate,
    parentOverrides
}) {
    const {
        id,
        valueType,
        required,
        label,
        editable,
        availableTypeListValues = [],
        currency,
        isUnique
    } = info;

    const path = `itemData.${id}.${valueTypeMap[valueType]}`;
    const dataType = getComponentDataType(info);
    const value = _.get(modalData, path);

    const metadata = {
        content: [{
            id: id,
            type: 'field',
            datatype: dataType,
            componentProps: {
                dataType: getPropDataType(info),
                required: required,
                availableValues: formatAvailableValues(availableTypeListValues),
                currency: currency,
                path: path,
                readOnly: !editable,
                label: label,
                value: value,
                validationMessages: getValidationMessage(
                    isUnique, scheduleItem, value, path, modalData, translator
                ),
                onValueChange: onValueChange,
                ...parentOverrides['@field']
            }
        }]
    };

    const isFieldValid = validateContentFromMetadata(metadata);
    useEffect(() => {
        if (onValidate) {
            onValidate(isFieldValid, id);
        }
    }, [onValidate, id, isFieldValid]);

    return renderContentFromMetadata(metadata);
}
